/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
	isSplash: true,  // Change this to false if you don't want Splash screen.
};


//Home Page
const greeting = {
	title: "Mohammad Basit 😎",
	logo_name: "M.Basit ",
	nickname: "",
	subTitle: "A Software Engineer with experience building stuff for the internet. Solving tough challenges and problems seems like a familiar cliché to me.",
};

const socialMediaLinks = {
	/* Your Social Media Link */
	github: "https://github.com/iambazzy",
	linkedin: "https://www.linkedin.com/in/bmir/",
	gmail: "mirbasit953@gmail.com",
	behance: "https://www.behance.net/basitmir",
};

const skills = {
	data: [
		{
			title: "Languages",
			fileName: "DataScienceImg",
			skills: [
				"⚡ Developing front end website architecture.",
				"⚡ Designing and developing REST APIs.",
				"⚡ Maintaining software workflow management."
			],
			softwareSkills: [
				{
					skillName: "Java Script",
					fontAwesomeClassname: "logos-javascript",
					style: {
						backgroundColor: "transparent"
					}
				},
				{
					skillName: "TypeScript",
					fontAwesomeClassname: "logos-typescript-icon",
					style: {
						backgroundColor: "white",
						color: "#D00000"
					}
				},
				{
					skillName: "Python",
					fontAwesomeClassname: "logos-python",
					style: {
						backgroundColor: "transparent",
						color: "#3776AB"
					}
				},
				{
					skillName: "C Basics",
					fontAwesomeClassname: "logos-c",
					style: {
						backgroundColor: "transparent",
						color: "#3776AB"
					}
				}
			]
		},
		{
			title: "Frameworks & Tools",
			fileName: "FullStackImg",
			skills: [
				"⚡ Building responsive websites using vanilla Html, Css and Js.",
				"⚡ Building responsive website front end using React, Redux, Vue, Vuex.",
				"⚡ Developing mobile applications using React Native, Redux.",
				"⚡ Developing Desktop applications using ElectronJs.",
				"⚡ Creating application backend in Node, Express and MongoDB.",
				"⚡ Developing a flexible and well-structured front-end Architecture, along with the API's to support it."
			],
			softwareSkills: [
				{
					skillName: "HTML5",
					fontAwesomeClassname: "simple-icons:html5",
					style: {
						color: "#E34F26"
					}
				},
				{
					skillName: "CSS3",
					fontAwesomeClassname: "simple-icons:css3",
					style: {
						color: "#1572B6"
					}
				},
				{
					skillName: "Bootstrap",
					fontAwesomeClassname: "logos-bootstrap",
					style: {
						color: "#CC6699"
					}
				},
				{
					skillName: "Sass",
					fontAwesomeClassname: "logos-sass",
					style: {
						color: "#F7DF1E"
					}
				},
				{
					skillName: "ReactJS",
					fontAwesomeClassname: "simple-icons:react",
					style: {
						color: "#61DAFB"
					}
				},
				{
					skillName: "ReactJS",
					fontAwesomeClassname: "simple-icons:angular",
					style: {
						color: "maroon"
					}
				},
				{
					skillName: "NodeJS",
					fontAwesomeClassname: "simple-icons:node-dot-js",
					style: {
						color: "#339933"
					}
				},
				{
					skillName: "NPM",
					fontAwesomeClassname: "simple-icons:npm",
					style: {
						color: "#CB3837"
					}
				},
				{
					skillName: "Redux",
					fontAwesomeClassname: "logos-redux",
					style: {
						color: "#2C8EBB"
					}
				},
				{
					skillName: "VueJs",
					fontAwesomeClassname: "logos-vue",
					style: {
						color: "#663399"
					}
				},
				{
					skillName: "Electron",
					fontAwesomeClassname: "logos-electron",
					style: {
						color: "#02569B"
					}
				}
			]
		},
		{
			title: "Cloud Skills",
			fileName: "CloudInfraImg",
			skills: [
				"⚡ Experience working on multiple cloud platforms.",
				"⚡ Deploying web apps backend on cloud to use on mobile devices.",
				"⚡ Experience using realtime databases.",
			],
			softwareSkills: [
				{
					skillName: "Firebase",
					fontAwesomeClassname: "simple-icons:firebase",
					style: {
						color: "orange"
					}
				},
				{
					skillName: "Heroku",
					fontAwesomeClassname: "simple-icons:heroku",
					style: {
						color: "purple"
					}
				},

			]
		},
		{
			title: "UI Design (Coding)",
			fileName: "DesignImg",
			skills: [
				"⚡ Designing highly attractive user interface for mobile and web applications",
				"⚡ Creating the flow of application functionalities to optimize user experience",
				"⚡ Bringing a designer’s concept to life with HTML, CSS, and JavaScript.",
				"⚡ Translating Adobe XD Designs And Wireframes Into High Quality Code."
			],
			softwareSkills: [
				{
					skillName: "Html 5",
					fontAwesomeClassname: "simple-icons:html5",
					style: {
						color: "orange"
					}
				},
				{
					skillName: "Css 3",
					fontAwesomeClassname: "simple-icons:css3",
					style: {
						color: "blue"
					}
				},
				{
					skillName: "Sass",
					fontAwesomeClassname: "simple-icons:sass",
					style: {
						color: "pink"
					}
				},
				{
					skillName: "Ui Kit",
					fontAwesomeClassname: "simple-icons:uikit",
					style: {
						color: "purple"
					}
				},
				{
					skillName: "Bulma",
					fontAwesomeClassname: "simple-icons:bulma",
					style: {
						color: "blue"
					}
				},
				{
					skillName: "Tailwind-css",
					fontAwesomeClassname: "simple-icons:tailwindcss",
					style: {
						color: "gray"
					}
				}
			]
		}
	]
};


// Education Page
const competitiveSites = {
	competitiveSites: []
}

const degrees = {
	degrees: [
		{
			title: "Indian Institute of Information Technology Kurnool",
			subtitle: "B.Tech. in Computer Engineering",
			duration: "2015 - 2019",
			descriptions: [
				"⚡ I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, CA, AI etc.",
				"⚡ Apart from this, I have done courses on Front End Web Dev, Backend Web Dev, MERN Stack, MEAN Stack, MEVN Stack, Advanced Javascript and Master Class Course on NodeJs.",
			],
		}
	]
}

const certifications = {
	certifications: [
		{
			title: "Advanced Javascript Concepts",
			subtitle: "Udemy",
			alt_name: "Udemy",
			color_code: "#8C151599"
		},
		{
			title: "Bootstrap with Jquery",
			subtitle: "Udemy",
			alt_name: "Udemy",
			color_code: "#8C151599"
		},
		{
			title: "HTML with CSS",
			subtitle: "Lynda.com",
			alt_name: "lynda.com",
			color_code: "#8C151599"
		},
		{
			title: "Intro to Vue Js",
			subtitle: "Vue Mastery",
			alt_name: "Udemy",
			color_code: "#8C151599"
		},
		{
			title: "Mongo DB with NodeJs",
			subtitle: "Udemy",
			alt_name: "Udemy",
			color_code: "#8C151599"
		},
		{
			title: "Node Js Master Class",
			subtitle: "Pirple",
			alt_name: "Udemy",
			color_code: "#8C151599"
		},
		{
			title: "React JS Front to Back",
			subtitle: "Udemy",
			alt_name: "Udemy",
			color_code: "#8C151599"
		},
		{
			title: "React Native with Redux",
			subtitle: "Udemy",
			alt_name: "Udemy",
			color_code: "#8C151599"
		},
		{
			title: "Web Scrapping Using Node Js",
			subtitle: "Udemy",
			alt_name: "Udemy",
			color_code: "#8C151599"
		},
	]
};


// Experience Page
const experience = {
	title: "Experience",
	subtitle: "Work and Internship",
	description:
		"I have worked on many freelance projects. I have experience working alongside graphic designers for web design features. Designing user interactions on web sites and testing websites during development for usability and fixing bugs. Construct Visualizations that are able to depict vast amounts of data.",
	header_image_path: "experience.svg",
	sections: [
		{
			title: "Work",
			experiences: [
				{
					title: "Associate Software Development Engineer",
					company: "Sonic Wall Inc.",
					company_url: "https://www.sonicwall.com/",
					logo_path: "https://www.optrics.com/img/products/Sonicwall/PartnerPage-Logos-Sonicwall-retina.png",
					duration: "June 2020 - Present",
					location: "Bangalore - India",
					description:
						"SonicWall, originally a private company headquartered in Silicon Valley, and a Dell subsidiary from 2012 to 2016, sells a range of Internet appliances primarily directed at content control and network security. These include devices providing services for network firewalls, unified threat management (UTM), virtual private networks (VPNs), and anti-spam for email. ",
					color: "orange",
				},
				{
					title: "Full Stack React Developer",
					company: "Modistabox Dubai.",
					company_url: "https://www.modistabox.com/",
					logo_path: "https://www.modistabox.com/5665e0763582178df27a4039ee5b7af3.svg",
					duration: "Nov 2019 - May 2020",
					location: "Bangalore, India",
					description:
						"Modistabox is a fashion tech start-up offering a personal styling service that delivers a curated box of products directly to customers across the MENA region. Modistabox handpicks products for each customer to ultimately help them look and feel their best staying in line with the current trends.",
					color: "#fc1f20",
				},
				{
					title: "Full Stack Developer",
					company: "Upwork.com",
					company_url: "https://upwork.com/",
					logo_path: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d2/Upwork-logo.svg/1280px-Upwork-logo.svg.png",
					duration: "March 2018 - February 2019",
					location: "Remote",
					description:
						"Upwork, formerly Elance-oDesk, is a global freelancing platform where businesses or individuals connect to conduct business. In 2015, Elance-oDesk was rebranded as Upwork. It is based in Santa Clara and San Francisco, California. The full name is Upwork Global Inc.",
					color: "green",
				},
			],
		},
	],
};

// Projects Page
const projectsHeader = {

};


// Contact Page
const contactPageData = {
	contactSection: {
		title: "Contact Me",
		profile_image_path: "https://media-exp1.licdn.com/dms/image/C5603AQFd9vGWuPZo8Q/profile-displayphoto-shrink_200_200/0?e=1600300800&v=beta&t=prGiMA5fE19sMqWK9BxCZ8fS54q_Ek40LZkfqukebSM",
		description:
			"I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with anything that is focused around Javascript and Typescript, Front End, Back End Development.",
	},
};

export {
	settings,
	greeting,
	socialMediaLinks,
	skills,
	competitiveSites,
	degrees,
	certifications,
	experience,
	projectsHeader,
	contactPageData,
};
